/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_TailoringInputs */

const en_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailoring...`)
};

const de_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird angepasst...`)
};

const fr_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptation en cours...`)
};

const es_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptando...`)
};

const it_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizzazione...`)
};

const nl_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op maat maken...`)
};

const pl_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosowywanie...`)
};

const fi_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räätälöidään...`)
};

const da_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skræddersyr...`)
};

const sv_jobs_tailoring = /** @type {(inputs: Jobs_TailoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skräddarsyr...`)
};

/**
* | output |
* | --- |
* | "Tailoring..." |
*
* @param {Jobs_TailoringInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tailoring = /** @type {((inputs?: Jobs_TailoringInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_TailoringInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tailoring(inputs)
	if (locale === "fr") return fr_jobs_tailoring(inputs)
	if (locale === "es") return es_jobs_tailoring(inputs)
	if (locale === "it") return it_jobs_tailoring(inputs)
	if (locale === "nl") return nl_jobs_tailoring(inputs)
	if (locale === "pl") return pl_jobs_tailoring(inputs)
	if (locale === "fi") return fi_jobs_tailoring(inputs)
	if (locale === "da") return da_jobs_tailoring(inputs)
	if (locale === "sv") return sv_jobs_tailoring(inputs)
	return en_jobs_tailoring(inputs)
});